var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  Booking\n  "),_c('router-link',{attrs:{"tag":"a","to":("/bookings/overview/:date?" + (_vm.eventLog.bookingId))}},[_vm._v("#"+_vm._s(_vm.eventLog.bookingId)+"\n  ")]),_vm._v("\n  moved\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }